import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getProjects } from "../utils/api";


export const fetchProjects = createAsyncThunk(
  'projects/fetchProjects',
  async ({ accessToken, query }, { rejectWithValue }) => {
    try {
      const response = await getProjects(accessToken, query);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

const projectsSlice = createSlice({
  name: 'projects',
  initialState: {
    projects: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchProjects.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchProjects.fulfilled, (state, action) => {
        state.loading = false;
        state.projects = action.payload;
      })
      .addCase(fetchProjects.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default projectsSlice.reducer;
